import { useCallback } from "react";
import { InterventionsProvider } from "@simplybusiness/mobius-interventions";
import { useAtomCallback } from "jotai/utils";
import { questionnaireAnswersAtom } from "../features/questionnaire/state/questionnaireAnswersAtom";
import { INACTIVITY_TIME } from "../constants/interventions";
import type { ReactNode } from "react";

type InterventionsProviderWithAnswersProps = {
  site: string;
  duid?: string;
  vertical?: string;
  disablePolling: boolean;
  children: ReactNode;
};

/**
 * Wrapper that must be rendered inside jotai's <Provider> so that
 * useAtomCallback binds to the scoped store where questionnaire
 * answers actually live.
 */
export function InterventionsProviderWithAnswers({
  site,
  duid,
  vertical,
  disablePolling,
  children,
}: InterventionsProviderWithAnswersProps) {
  const getAnswers = useAtomCallback(
    useCallback(get => get(questionnaireAnswersAtom), []),
  );

  return (
    <InterventionsProvider
      site={site}
      duid={duid}
      vertical={vertical}
      inactivityTime={INACTIVITY_TIME}
      disablePolling={disablePolling}
      getAnswers={getAnswers}
    >
      {children}
    </InterventionsProvider>
  );
}
